import React, { useState } from 'react';
import TextField from '@material-ui/core/TextField';

import { t } from './common/LocalizationProvider';
import EditItemView from './shared/EditItemView';
import { Accordion, AccordionSummary, AccordionDetails, makeStyles, Typography } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import EditAttributesView from './attributes/EditAttributesView';
import geofenceAttributes from './attributes/geofenceAttributes';
import {cyberStyles} from "./cssShared/cyberTheme";

const useStyles = makeStyles((theme) => ({
  ...cyberStyles(theme),
}));

const GeofencePage = () => {
  const classes = useStyles();

  const [item, setItem] = useState();
  return (
      <EditItemView endpoint="geofences" item={item} setItem={setItem}>
        {item &&
            <>
              <Accordion defaultExpanded className={classes.accordion}>
                <AccordionSummary expandIcon={<ExpandMoreIcon style={{color: '#00f2ff'}} />}>
                  <Typography className={classes.summaryText}>
                    {t('sharedRequired')}
                  </Typography>
                </AccordionSummary>
                <AccordionDetails className={classes.details}>
                  <TextField
                      className={classes.neonInput}
                      margin="normal"
                      value={item.name || ''}
                      onChange={event => setItem({...item, name: event.target.value})}
                      label={t('sharedName')}
                      variant="filled" />
                </AccordionDetails>
              </Accordion>

              <Accordion defaultExpanded className={classes.accordion}>
                <AccordionSummary expandIcon={<ExpandMoreIcon style={{color: '#00f2ff'}} />}>
                  <Typography className={classes.summaryText}>
                    {t('sharedAttributes')}
                  </Typography>
                </AccordionSummary>
                <AccordionDetails className={classes.details}>
                  <EditAttributesView
                      attributes={item.attributes}
                      setAttributes={attributes => setItem({...item, attributes})}
                      definitions={geofenceAttributes}
                  />
                </AccordionDetails>
              </Accordion>
            </>
        }
      </EditItemView>
  );
}

export default GeofencePage;
